import { ChartJson } from 'src/app/reports/service/people-counters-chart-data-preparator.service';

export interface ChartConfig {
  responsive?: boolean;
  locale: string;
  modeBarButtonsToRemove: string[];
  modeBarButtonsToAdd?: ModeBarButton[];
  toImageButtonOptions: ExportChartOptions;
}

export interface ExportChartOptions {
  format?: 'png' | 'jpeg' | 'svg' | 'webp';
  filename?: string;
  height?: number;
  width?: number;
  scale?: number;
}

export interface ModeBarButton {
  name: string;
  icon: PlotlyIcon;
  click: ModeBarClick;
}

export interface PlotlyIcon {
  width: number;
  height: number;
  path: string;
  transform?: string;
}

export const plotlyDefaultIcons = {
  pencil: {
    width: 1792,
    height: 1792,
    // eslint-disable-next-line max-len
    path: 'M491 1536l91-91-235-235-91 91v107h128v128h107zm523-928q0-22-22-22-10 0-17 7l-542 542q-7 7-7 17 0 22 22 22 10 0 17-7l542-542q7-7 7-17zm-54-192l416 416-832 832h-416v-416zm683 96q0 53-37 90l-166 166-416-416 166-165q36-38 90-38 53 0 91 38l235 234q37 39 37 91z',
    transform: 'matrix(1 0 0 1 0 1)'
  }
};

export type ModeBarClick = (chartJson: ChartJson) => void;
